import { XLg } from 'react-bootstrap-icons';
import './FormStyles.css';

interface FromAlertProps {
    children?: React.ReactNode;
    onClose: () => void;
}

const FromAlert: React.FC<FromAlertProps> = ({ children, onClose  }) => {
    return (
        <div className='fromAlert'>
            <div>
                {children}
                <XLg className='alert_closeButton' onClick={onClose} />
            </div>
        </div>
    );
}

export default FromAlert;